// extracted by mini-css-extract-plugin
export default {"container":"featured-header_container__2VOSw","topics":"featured-header_topics__2QSKX","button":"featured-header_button__2zEOT"};